import { subjectQueryOptions } from '@features/groups/queries'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId')({
    component: Outlet,
    loader: async ({ params, context }) => {
        return context.queryClient.ensureQueryData(subjectQueryOptions({ mode: 'id', id: params.subjectId }))
    },
    staticData: {
        crumb: {
            dynamicLabel(match) {
                return `${match.loaderData?.programmeName} (Subject)`
            },
        }
    }
})